<template>
    <div class='row preg'>
        <div class='col-sm-12'>
            <div :class="ingresado ? 'bg-primary' : pregunta.obligatoria ? 'obligatoria' : ''">
                <span v-if="muestraP">{{ pregunta.pregunta }}</span>
                {{ pregunta.literal }}<br />
            </div>
            <div class='btn-group'>
                <button :disabled="ingresado" @click="modificaValor('cumple')" :class="texto == 'cumple' ? 'btn btn-primary' : 'btn'" type='button'>Cumple</button>
                <button :disabled="ingresado" @click="modificaValor('no cumple')" :class="texto == 'no cumple' ? 'btn btn-primary' : 'btn'" type='button'>No cumple</button>
                <button :disabled="ingresado" @click="modificaValor('no aplica')" :class="texto == 'no aplica' ? 'btn btn-primary' : 'btn'" type='button'>No aplica</button>
            </div>
        </div>
    </div>
</template>

<script>
    import moment from 'moment';

    export default {
        props: ['pregunta', 'evaluacion_id', 'muestraP'],
        data() {
            return {
                ingresado: false,
                texto: null
            }
        },
        methods: {
            modificaValor(valor){
                this.texto = valor;
                this.creaEvaluacionDetalle();
            },
            creaEvaluacionDetalle() {
                axios.post('/api/evaluacion_detalle/' + this.evaluacion_id, 
                    {
                        'hora_ini_app' : moment().format('H:mm:ss'),
                        'preguntas_paso_servicio_id' : this.pregunta.id,
                        'pregunta_texto' : this.pregunta.pregunta,
                        'valor' : null,
                        'texto' : this.texto,
                        'completo' : true
                    }
                )
                .then(response => {
                    this.ingresado = true;
                    this.$emit('update:actualiza', response.data.data);

                })
                .catch(error => {
                    this.form.errors = ['Something went wrong. Please try again.'];
                });
            }
        },
    }
</script>

<style lang="scss" scoped>
    .obligatoria{
        background-color: #ff0000;
        color: #FFFFFF;
    }

    .bg-primary {
		background-color: #1ab394;
		border-color: #1ab394;
		color: #FFFFFF;
	}
</style>